/* R44 — Halloween 2026 "Spin the Pumpkin" SMS signup (markup + settings: sections/r44-pumpkin-spin.liquid)
   Flow: first name + mobile + SMS consent -> prize picked by weight -> pumpkin spins to it while the visitor is
   saved to Klaviyo (profile properties first, then SMS-subscribed to the list so the list-triggered flow already
   sees the prize) -> result shows the prize; the code itself arrives by text from the Klaviyo flow.
   Test: ?r44_spin_test=1 opens it straight away and ignores "already spun" (?r44_spin_test=0 to stop). */
(function () {
  'use strict';
  var root = document.getElementById('r44ps');
  var cfgEl = document.querySelector('[data-r44ps-config]');
  if (!root || !cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KEY = cfg.key, LIST = cfg.list, SOURCE = cfg.source || 'Halloween 2026 Pumpkin Spin';
  var DONE_KEY = 'r44-pumpkin-spin-2026', DISMISS_KEY = 'r44-pumpkin-spin-dismissed';
  var prizes = (cfg.prizes || []).filter(function (p) { return p && p.key && p.wheel; });
  if (!prizes.length) return;

  function getLS(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function getSS(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function setSS(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function rand() {
    try { var a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] / 4294967296; } catch (e) { return Math.random(); }
  }

  var testMode = false;
  try {
    if (/[?&]r44_spin_test=1/.test(location.search)) sessionStorage.setItem('r44-spin-test', '1');
    if (/[?&]r44_spin_test=0/.test(location.search)) sessionStorage.removeItem('r44-spin-test');
    testMode = sessionStorage.getItem('r44-spin-test') === '1';
  } catch (e) {}
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Submitted once = never shown again on this browser (localStorage, with a 1-year cookie as a backup)
  function hasDone() { return !!getLS(DONE_KEY) || /(?:^|;\s*)r44ps_done=1/.test(document.cookie); }
  function markDone(prizeKey) {
    setLS(DONE_KEY, JSON.stringify({ prize: prizeKey, at: Date.now() }));
    try { document.cookie = 'r44ps_done=1; max-age=31536000; path=/; SameSite=Lax'; } catch (e) {}
  }
  var alreadySpun = hasDone() && !testMode && !designMode;

  // Time on the site this visit, counted across page views (sessionStorage keeps the visit's start time)
  var START_KEY = 'r44-pumpkin-spin-visit-start';
  var visitStart = +getSS(START_KEY) || 0;
  if (!visitStart) { visitStart = Date.now(); setSS(START_KEY, String(visitStart)); }
  function msUntilReady() { return Math.max(0, (+cfg.delay || 0) * 1000 - (Date.now() - visitStart)); }

  /* ---------------------------------------------------------------------------------------------------------
     Pumpkin (seen from above: ribbed lobes radiate from the stem, so each lobe is a prize segment)
     --------------------------------------------------------------------------------------------------------- */
  var R = 230, ORDER = [];
  // Two of each prize, alternating so neighbours differ: 1, 3, 2, 4, 1, 3, 2, 4
  (function () {
    var base = prizes.length === 4 ? [0, 2, 1, 3] : prizes.map(function (_, i) { return i; });
    var reps = Math.max(1, Math.round(8 / base.length));
    for (var r = 0; r < reps; r++) ORDER = ORDER.concat(base);
  })();
  var N = ORDER.length, SEG = 360 / N;

  function pt(r, deg) {
    var a = deg * Math.PI / 180;
    return (r * Math.sin(a)).toFixed(2) + ',' + (-r * Math.cos(a)).toFixed(2);
  }
  function lobePath(i) {
    var a0 = i * SEG - SEG / 2, a1 = a0 + SEG, k = SEG * 0.22;
    return 'M0,0L' + pt(R * 0.88, a0) + 'C' + pt(R * 1.04, a0 + k) + ' ' + pt(R * 1.04, a1 - k) + ' ' + pt(R * 0.88, a1) + 'Z';
  }
  function groovePath(i) {
    var a = i * SEG - SEG / 2;
    return 'M' + pt(R * 0.13, a) + 'Q' + pt(R * 0.52, a + 2.5) + ' ' + pt(R * 0.885, a);
  }
  function lobeText(i) {
    var p = prizes[ORDER[i]];
    var lines = String(p.wheel).split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    var rows = lines.map(function (t, j) {
      var big = j === 0, size = big ? (t.length <= 4 ? 32 : 19) : 11.5;
      return { t: t, size: size, h: big ? size * 1.02 : 14.5, big: big };
    });
    var total = rows.reduce(function (s, r) { return s + r.h; }, 0), y = -total / 2, out = '';
    rows.forEach(function (r) {
      var cy = (y + r.h / 2).toFixed(1);
      var cls = 'r44ps-t' + (r.big ? ' r44ps-t--big' : '');
      out += '<text class="' + cls + ' r44ps-t--hi" x="0.8" y="' + (+cy + 0.9) + '" font-size="' + r.size + '">' + esc(r.t) + '</text>';
      out += '<text class="' + cls + '" x="0" y="' + cy + '" font-size="' + r.size + '">' + esc(r.t) + '</text>';
      y += r.h;
    });
    return '<g transform="rotate(' + (i * SEG) + ') translate(0,' + (-R * 0.56).toFixed(1) + ') rotate(-90)">' + out + '</g>';
  }

  function calyxPath() {
    var pts = 5, rOut = R * 0.22, rIn = R * 0.1, d = '';
    for (var i = 0; i < pts; i++) {
      var a = i * 360 / pts + 12, b = a + 360 / pts / 2, c = a + 360 / pts;
      if (i === 0) d += 'M' + pt(rIn, a);
      d += 'Q' + pt(rOut * 1.08, b - 9) + ' ' + pt(rOut, b) + 'Q' + pt(rOut * 1.02, b + 11) + ' ' + pt(rIn, c);
    }
    return d + 'Z';
  }

  function buildPumpkin() {
    var lobes = '', grooves = '', texts = '', shines = '', lobeEdges = '', streaks = '', rims = '';
    for (var i = 0; i < N; i++) {
      lobes += '<path d="' + lobePath(i) + '" fill="url(#r44ps-g' + (i % 2 ? 'B' : 'A') + ')"/>';
      lobeEdges += '<path d="' + lobePath(i) + '"/>';
      var a0 = i * SEG - SEG / 2, a1 = a0 + SEG, k = SEG * 0.22;
      rims += '<path d="M' + pt(R * 0.88, a0) + 'C' + pt(R * 1.04, a0 + k) + ' ' + pt(R * 1.04, a1 - k) + ' ' + pt(R * 0.88, a1) + '"/>';
      [-0.28, 0.3].forEach(function (f) {
        var m = i * SEG + f * SEG;
        streaks += '<path d="M' + pt(R * 0.3, m) + 'Q' + pt(R * 0.62, m + f * 6) + ' ' + pt(R * 0.86, m + f * 3) + '"/>';
      });
      grooves += '<path d="' + groovePath(i) + '"/>';
      shines += '<ellipse cx="0" cy="' + (-R * 0.6).toFixed(1) + '" rx="' + (R * 0.055).toFixed(1) + '" ry="' + (R * 0.24).toFixed(1) + '" transform="rotate(' + (i * SEG - SEG * 0.12) + ')"/>';
      texts += lobeText(i);
    }
    var ridges = '';
    for (var j = 0; j < 9; j++) ridges += '<path d="M' + pt(R * 0.035, j * 40) + 'L' + pt(R * 0.098, j * 40 + 6) + '"/>';
    return '' +
      '<svg viewBox="-262 -262 524 524" xmlns="http://www.w3.org/2000/svg" class="r44ps-svg">' +
        '<defs>' +
          '<radialGradient id="r44ps-gA" cx="0" cy="0" r="' + R + '" gradientUnits="userSpaceOnUse">' +
            '<stop offset="0" stop-color="#ffb867"/><stop offset=".42" stop-color="#fb8a24"/><stop offset=".78" stop-color="#e3620c"/><stop offset="1" stop-color="#9e3802"/>' +
          '</radialGradient>' +
          '<radialGradient id="r44ps-gB" cx="0" cy="0" r="' + R + '" gradientUnits="userSpaceOnUse">' +
            '<stop offset="0" stop-color="#ffc278"/><stop offset=".42" stop-color="#ff942f"/><stop offset=".78" stop-color="#ec6d14"/><stop offset="1" stop-color="#a83e04"/>' +
          '</radialGradient>' +
          '<radialGradient id="r44ps-stem" cx="-6" cy="-8" r="' + (R * 0.12) + '" gradientUnits="userSpaceOnUse">' +
            '<stop offset="0" stop-color="#b08a52"/><stop offset=".55" stop-color="#6e4a24"/><stop offset="1" stop-color="#3a2612"/>' +
          '</radialGradient>' +
          '<radialGradient id="r44ps-calyx" cx="0" cy="0" r="' + (R * 0.24) + '" gradientUnits="userSpaceOnUse">' +
            '<stop offset="0" stop-color="#5d5a26"/><stop offset="1" stop-color="#2f3011"/>' +
          '</radialGradient>' +
          '<filter id="r44ps-blur4" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="3.2"/></filter>' +
          '<filter id="r44ps-blur8" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="7"/></filter>' +
        '</defs>' +
        '<g class="r44ps-lobes">' + lobes + '</g>' +
        // rounded lobe edges: a soft dark rim inside every lobe
        '<g fill="none" stroke="#6a2301" stroke-width="16" stroke-linejoin="round" opacity=".38" filter="url(#r44ps-blur8)">' + lobeEdges + '</g>' +
        '<g fill="#fff" opacity=".13" filter="url(#r44ps-blur8)">' + shines + '</g>' +
        '<g fill="none" stroke="#ffd7a8" stroke-width="1" opacity=".16" stroke-linecap="round">' + streaks + '</g>' +
        '<g fill="none" stroke="#4a1700" stroke-width="12" stroke-linecap="round" opacity=".45" filter="url(#r44ps-blur4)">' + grooves + '</g>' +
        '<g fill="none" stroke="#3d1300" stroke-width="1.4" stroke-linecap="round" opacity=".55">' + grooves + '</g>' +
        '<g fill="none" stroke="#7a2a02" stroke-width="1.2" opacity=".8">' + rims + '</g>' +
        '<g class="r44ps-texts">' + texts + '</g>' +
        '<path d="M' + pt(R * 0.12, 205) + 'c-14,10 -30,26 -22,40 c7,12 24,4 20,-8 c-3,-9 -14,-6 -12,2" fill="none" stroke="#56622a" stroke-width="3.2" stroke-linecap="round"/>' +
        '<path d="M' + pt(R * 0.16, 40) + 'c18,-12 46,-10 56,6 c-16,10 -42,12 -56,-6z" fill="#3f5a1f" opacity=".95"/>' +
        '<path d="M' + pt(R * 0.16, 40) + 'c18,-2 34,0 50,5" fill="none" stroke="#2a3d12" stroke-width="1.2"/>' +
        '<path d="' + calyxPath() + '" fill="url(#r44ps-calyx)" stroke="#1f200a" stroke-width="1.2"/>' +
        '<circle r="' + (R * 0.11).toFixed(1) + '" fill="url(#r44ps-stem)" stroke="#2a1a0b" stroke-width="1.5"/>' +
        '<g stroke="#2a1a0b" stroke-width="1.6" stroke-linecap="round" opacity=".55">' + ridges + '</g>' +
        '<ellipse cx="-7" cy="-9" rx="8" ry="5" fill="#fff" opacity=".18" transform="rotate(-30 -7 -9)"/>' +
      '</svg>';
  }

  function buildOverlay() {
    // Static soft highlight (stays put while the pumpkin turns underneath)
    return '' +
      '<svg viewBox="-262 -262 524 524" xmlns="http://www.w3.org/2000/svg" class="r44ps-svg">' +
        '<defs>' +
          '<radialGradient id="r44ps-hl" cx="-70" cy="-90" r="' + (R * 0.95) + '" gradientUnits="userSpaceOnUse">' +
            '<stop offset="0" stop-color="#fff" stop-opacity=".2"/><stop offset=".55" stop-color="#fff" stop-opacity="0"/>' +
          '</radialGradient>' +
        '</defs>' +
        '<circle r="' + (R * 0.9).toFixed(1) + '" fill="url(#r44ps-hl)"/>' +
      '</svg>';
  }
  function buildPin() {
    // Pointer is its own small element so its tick animation never repaints the pumpkin
    return '<div class="r44ps__pin-in"><svg viewBox="-21 -258 42 72" xmlns="http://www.w3.org/2000/svg">' +
        '<defs><filter id="r44ps-pin" x="-60%" y="-40%" width="220%" height="200%"><feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#000" flood-opacity=".55"/></filter></defs>' +
        '<g filter="url(#r44ps-pin)">' +
          '<path d="M0,-188 C-7,-205 -19,-222 -19,-236 A19,19 0 1 1 19,-236 C19,-222 7,-205 0,-188Z" fill="#f7f3ee"/>' +
          '<circle cx="0" cy="-236" r="7.5" fill="#ff7a1a"/>' +
          '<circle cx="0" cy="-236" r="7.5" fill="none" stroke="#ffd2a8" stroke-width="1" opacity=".7"/>' +
        '</g>' +
      '</svg></div>';
  }

  var rotor = root.querySelector('[data-r44ps-rotor]');
  var built = false;
  function ensureBuilt() {
    if (built) return;
    built = true;
    rotor.innerHTML = buildPumpkin();
    var overlay = root.querySelector('[data-r44ps-overlay]');
    overlay.innerHTML = buildOverlay();
    var pin = document.createElement('div');
    pin.className = 'r44ps__pin';
    pin.innerHTML = buildPin();
    overlay.parentNode.appendChild(pin);
    rotor.style.transform = 'rotate(' + rotation + 'deg)';
  }

  /* ---------------------------------------------------------------------------------------------------------
     Spin
     --------------------------------------------------------------------------------------------------------- */
  var rotation = -SEG * 0.5; // start with a groove under the pointer so no prize is "pre-selected"
  function pickPrize() {
    var total = prizes.reduce(function (s, p) { return s + Math.max(0, +p.weight || 0); }, 0);
    if (total <= 0) return 0;
    var r = rand() * total;
    for (var i = 0; i < prizes.length; i++) {
      r -= Math.max(0, +prizes[i].weight || 0);
      if (r < 0) return i;
    }
    return prizes.length - 1;
  }
  function spinTo(prizeIdx) {
    var lobes = [];
    ORDER.forEach(function (p, i) { if (p === prizeIdx) lobes.push(i); });
    var lobe = lobes[Math.floor(rand() * lobes.length)];
    var jitter = (rand() - 0.5) * SEG * 0.6;
    var target = ((-(lobe * SEG) + jitter) % 360 + 360) % 360;
    var turns = reduceMotion ? 1 : 6;
    var next = rotation - (((rotation % 360) + 360) % 360) + 360 * turns + target;
    if (next - rotation < 360) next += 360;
    var dur = reduceMotion ? 1200 : 5600;
    rotation = next;
    rotor.style.transition = 'transform ' + dur + 'ms cubic-bezier(.13,.62,.11,1)';
    root.classList.add('is-spinning');
    // force reflow so the transition always runs
    void rotor.offsetWidth;
    rotor.style.transform = 'rotate(' + next + 'deg)';
    return new Promise(function (res) {
      setTimeout(function () {
        root.classList.remove('is-spinning');
        root.classList.add('is-landed');
        res();
      }, dur + 150);
    });
  }

  /* ---------------------------------------------------------------------------------------------------------
     Klaviyo
     --------------------------------------------------------------------------------------------------------- */
  function kl(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KEY), {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status !== 202 && !r.ok) {
        return r.text().then(function (t) { console.warn('[R44 pumpkin spin] Klaviyo ' + path + ':', r.status, t); throw new Error('status ' + r.status); });
      }
      return r;
    });
  }
  function saveToKlaviyo(entry) {
    var p = prizes[entry.prize];
    var props = {
      'Pumpkin Spin Prize': p.key,
      'Pumpkin Spin Prize Label': p.label,
      'Pumpkin Spin Date': new Date().toISOString(),
      'Signup Source': SOURCE,
      'Signup Page': location.pathname
    };
    // 1) Name + prize on the profile first, so the list-triggered SMS flow can already split on the prize
    return kl('profiles', { data: { type: 'profile', attributes: {
      phone_number: entry.phone, first_name: entry.first, properties: props
    } } }).catch(function () { /* non-fatal: the subscription below also carries the prize */ }).then(function () {
      // 2) SMS marketing consent + add to the list
      return kl('subscriptions', { data: { type: 'subscription', attributes: {
        custom_source: SOURCE,
        profile: { data: { type: 'profile', attributes: {
          phone_number: entry.phone, properties: props,
          subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: LIST } } } } });
    }).then(function () {
      // 3) A spin event on EVERY spin: this triggers the prize-text flow, so people already on the list
      //    (repeat spins, existing profiles) still get their code
      return kl('events', { data: { type: 'event', attributes: {
        properties: { 'Prize': p.key, 'Prize Label': p.label, 'Page': location.pathname },
        unique_id: 'pumpkin-' + entry.phone + '-' + Date.now(),
        metric: { data: { type: 'metric', attributes: { name: 'Pumpkin Spin Prize Won' } } },
        profile: { data: { type: 'profile', attributes: { phone_number: entry.phone, first_name: entry.first, properties: props } } }
      } } });
    }).then(function () {
      try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ phone_number: entry.phone, first_name: entry.first }); } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'pumpkin_spin_signup', { prize: p.key }); } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('r44_pumpkin_spin', { prize: p.key }); } catch (e) {}
    });
  }

  /* ---------------------------------------------------------------------------------------------------------
     Form
     --------------------------------------------------------------------------------------------------------- */
  var form = root.querySelector('[data-r44ps-form]');
  var msg = root.querySelector('[data-r44ps-msg]');
  var submitBtn = root.querySelector('[data-r44ps-submit]');
  var submitLabel = submitBtn.textContent;
  var pending = null; // spun but not yet saved (save failed) -> retry without re-spinning

  function say(text, type) {
    msg.hidden = !text;
    msg.textContent = text || '';
    msg.className = 'r44ps__msg' + (type ? ' is-' + type : '');
  }
  function toE164(cc, raw) {
    var v = String(raw || '').trim();
    if (/^\+/.test(v) || /^00/.test(v)) {
      var d = v.replace(/^00/, '').replace(/\D/g, '');
      return d.length >= 8 && d.length <= 15 ? '+' + d : null;
    }
    var n = v.replace(/\D/g, '');
    if (n.indexOf(cc) === 0 && n.length > cc.length + 8) n = n.slice(cc.length); // typed the country code without +
    n = n.replace(/^0+/, '');
    var full = cc + n;
    return n.length >= 6 && full.length <= 15 ? '+' + full : null;
  }
  function maskPhone(e) { return 'your number ending ' + e.slice(-3); }

  function showResult(entry) {
    var p = prizes[entry.prize];
    root.querySelector('[data-r44ps-prize]').textContent = p.label;
    var text = String(cfg.resultText || '')
      .replace(/\[name\]/g, entry.first)
      .replace(/\[phone\]/g, maskPhone(entry.phone));
    root.querySelector('[data-r44ps-result-text]').textContent = text;
    root.querySelector('[data-r44ps-step="form"]').hidden = true;
    root.querySelector('[data-r44ps-step="result"]').hidden = false;
    root.classList.add('is-won');
    var b = root.querySelector('[data-r44ps-step="result"] .r44ps__btn');
    if (b) setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (e) {} }, 60);
    if (teaser) teaser.hidden = true;
  }

  function lock(on) {
    submitBtn.disabled = on;
    Array.prototype.forEach.call(form.elements, function (el) { if (el !== submitBtn) el.disabled = on; });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (root.classList.contains('is-spinning')) return;

    if (pending) { // retry the save only
      lock(true); say('Sending…');
      saveToKlaviyo(pending).then(function () {
        showResult(pending); pending = null;
      }, function () {
        lock(false); say("We couldn't reach our texting service. Please check your number and try again.", 'error');
      });
      return;
    }

    var first = (form.first_name.value || '').trim();
    var phone = toE164(form.cc.value, form.phone.value);
    if (!first) { say('Please add your first name.', 'error'); form.first_name.focus(); return; }
    if (!phone) { say('Please enter a valid mobile number.', 'error'); form.phone.focus(); return; }
    if (!LIST || !KEY) { say('Sorry, this offer is not available right now.', 'error'); return; }

    var entry = { first: first.slice(0, 40), phone: phone, prize: pickPrize() };
    markDone(prizes[entry.prize].key);
    alreadySpun = true;
    lock(true); say('');
    submitBtn.textContent = 'Spinning…';

    Promise.all([
      spinTo(entry.prize),
      saveToKlaviyo(entry).then(function () { return true; }, function () { return false; })
    ]).then(function (res) {
      submitBtn.textContent = submitLabel;
      if (res[1]) {
        showResult(entry);
      } else {
        pending = entry;
        lock(false);
        form.first_name.disabled = true; form.cc.disabled = false; form.phone.disabled = false;
        submitBtn.textContent = 'Send my prize';
        say('You won ' + prizes[entry.prize].label + '! But we couldn’t text it to that number — please check it and try again.', 'error');
      }
    });
  });

  /* ---------------------------------------------------------------------------------------------------------
     Open / close
     --------------------------------------------------------------------------------------------------------- */
  var teaser = document.querySelector('[data-r44ps-open]');
  var lastFocus = null, isOpen = false;

  function otherOverlayOpen() {
    var html = document.documentElement;
    return html.classList.contains('r44gw-open') || !!document.querySelector('.drawer[open], dialog[open], .modal[open]');
  }

  function open(auto) {
    if (isOpen) return;
    if (alreadySpun && !root.classList.contains('is-won') && !pending) return;
    if (auto && (getSS(DISMISS_KEY) || otherOverlayOpen())) return;
    ensureBuilt();
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('r44ps-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () {
      var f = root.querySelector('[data-r44ps-step="form"]:not([hidden]) input[name="first_name"]') || root.querySelector('.r44ps__dialog');
      try { f.focus({ preventScroll: true }); } catch (e) {}
    }, 80);
  }
  function close() {
    if (!isOpen || root.classList.contains('is-spinning')) return;
    isOpen = false;
    setSS(DISMISS_KEY, '1');
    root.classList.remove('is-open');
    document.documentElement.classList.remove('r44ps-lock');
    setTimeout(function () { if (!isOpen) root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-r44ps-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(root.querySelectorAll('button, input, select, a[href]'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  function showTeaser() {
    if (!teaser || alreadySpun) return;
    teaser.hidden = false;
    requestAnimationFrame(function () { teaser.classList.add('is-in'); });
  }
  if (teaser) teaser.addEventListener('click', function () { open(false); });

  if (testMode) {
    setTimeout(function () { open(false); showTeaser(); }, 300);
  } else if (!alreadySpun && !designMode) {
    // Nothing appears until the visitor has spent the set time on the site (counted across pages)
    setTimeout(function () {
      if (alreadySpun) return;
      showTeaser();
      if (+cfg.delay > 0 || cfg.autoOpen) open(true);
    }, msUntilReady());
    if (cfg.exitIntent && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 4 && msUntilReady() === 0) open(true);
      });
    }
  }

  // Theme editor: open when the section is selected so it can be styled
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.contains && e.target.contains(root)) open(false);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.contains && e.target.contains(root)) close();
  });
})();
